module.exports = __webpack_public_path__ + "static/media/default.bba23291.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/invitation-page/default.png
// module id = 1302
// module chunks = 2 3 4 12 21 22 24 32 33 34 45